module.exports = __webpack_public_path__ + "img/signature-lock.cc72ccaf.svg";